import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'
import Carousel from '@/views/Carousel'
import Article from '@/views/Article'
import TabConfig from '@/views/TabConfig'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'carousel',
          name: 'Carousel',
          component: Carousel,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'article',
          name: 'Article',
          component: Article,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'tab-config',
          name: 'TabConfig',
          component: TabConfig,
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js